export const KEYS = {
    ENCRYPTED_PAYLOAD: "dkerakt",
    AES_KEY_HEX: "kwmowe",
    IV_HEX: "vwjpwb",
    MAC: "vkritkpw",
    CONVERSATION_ID: "pofwtu",
    PRELOGIN_SSID: "rdisl",
    POSTLOGIN_SSID: "odisl",
    ARCHIVEMESSAGE_TOKEN: "arctkn",
    ARCHIVECHAT_ID: "arccid",
};

export const GREETING_MSG_PRE =
    "<p>Hello, I’m your virtual banking assistant from Hong Leong Bank.</p><p>Ask me anything about our products and services.</p><p>Tip: If you would like us to recommend Shariah compliant products, just enter 'I'm interested in Islamic banking products'</p><p>Security Notice: Never share personal info, username/password or OTP in this chat session.</p>";
export const GREETING_SERVICE_SELECTION_SERVICE =
    "<p>Please select service</p>";
export const GREETING_MSG_POST =
    "Hello, I’m Hong Leong Bank’s A.I chat service. I can answer any questions you have about our products and services. ";
export const GREETING_MSG_POST2 =
    "Disclaimer: HLISB does not provide advice or promote, directly or indirectly, any banking products and services that are non-Shariah compliant.";
export const GREETING_MSG_POST3 =
    "If you have questions about your credit card, I can also help with that!\n\nFor example, you can ask me:\n<ul><li>How much can I apply for a Flexi Payment Plan?</li><li>What is the minimum I should pay on my credit card?</li><li>How do I check the available balance on my credit card?</li></ul>";
export const OUTSIDE_OPERATION_MSG =
    "Our operating hour is 9am to 7pm from Monday to Saturday. Please come back again at the time. Thank you for your understanding.";
export const IDLE_MSG =
    "I hope I was able to fully assist you today. Is there anything else I can help you with before I close this chat?";
export const TRY_MY_BEST_MSG = "I will try my best to answer your questions.";
export const WAIT_MSG =
    "I am now transferring you to a live chat agent. Kindly wait a moment.";
export const PROMOTION_MSG =
    "While waiting, check out our latest promotions on https://www.hlb.com.my/main/promotions";
export const QUEUE_MSG =
    "You are in the queue to be connected with a live agent. We appreciate your patience and we'll connect you as soon as possible.";
export const CONNECTED_LIVE_AGENT_MSG = "You are connected to live agent.";
export const LIVE_AGENT_UNAVAILABLE_MSG =
    "Our Live Agent is not available at the moment. Please try again later. Thank you.";
export const END_MSG =
    "<p>Thank you for contacting Hong Leong Bank, and have a pleasant day!</p>";
export const END_MSG_CHECKER =
    "<p>Thank you for contacting Hong Leong Bank, and have a pleasant day!</p><p>A quick survey will appear after the chat window is closed. </p><p>We truly value your feedback, and if you were satisfied, a 5-star rating helps us know we're meeting your needs.</p>"
export const END_MSG_QUIT_BUTTON =
    "<p>Thank you for contacting Hong Leong Bank, and have a pleasant day!</p>";
export const INPUT_PLACEHOLDER_MSG_PRELOGIN =
    "Type your message here. We will protect your information under PDPA 2010 but please do not reveal any personal information e.g. IC number, card or account numbers.";
export const INPUT_PLACEHOLDER_MSG_POSTLOGIN =
    "Type your message here. We will protect your information under PDPA 2010 but please do not reveal any personal information e.g. IC number, card or account numbers.";
export const INPUT_PLACEHOLDER_MSG = "Type your message here";
export const SURVEY_AGENT = "https://survey.hlb.com.my/EFM/se/682C0D24033B15EE";
export const SURVEY_BOT = "https://survey.hlb.com.my/EFM/se/682C0D2464768BB4";
export const CHARACTER_LIMIT = 200;
export const QUERY_PARAMS = window.location.search.substring(1);
export const INTERNAL_PARAM = "m=int";
export const QUEUE_RETRY_COUNT = 30;
export const ERROR_MSG =
    "Im unable to proceed with the question. Please try again";
export const NOT_FOUND_MENU_MSG = `I'm sorry, as an A.I Chat Service, I am unable to assist you with that question at this time. Please type "Chat Now" to connect to our Senior Specialist.`;

export const USER_DATA = JSON.parse(
    userDataString.replace(/(\w+):/g, '"$1":').replace(/'/g, '"')
);
export const CHAT_SESSION_ID = USER_DATA.chatSessionID;
export const SOURCE_CHAT = USER_DATA.SourceChat;
export const IS_LOGIN =
    USER_DATA.isLoginInFlag.toString().toLowerCase() === "true";

export const CATEGORIES = {
    CASAFD: "Current / Savings / Fixed Deposit",
    LostCard: "Report Lost Card / Fraudulent Transaction",
    HirePurchase: "Hire Purchase",
    PersonalLoans: "Personal Loans",
    Mortgage: "Mortgage",
    DebitCard: "Debit Card / Deposit Account",
    CreditCard: "Credit Card",
    HLConnect: "Hong Leong Connect",
};

export const CATEGORIES_DIV = {
    "category-casa-fd": "CASAFD",
    "category-report-lost": "LostCard",
    "category-auto-loan": "HirePurchase",
    "category-personal-loan": "PersonalLoans",
    "category-mortgage": "Mortgage",
    "category-debit-card": "DebitCard",
    "category-credit-card": "CreditCard",
    "category-hlb-connect": "HLConnect",
};

export const ALLOWED_HOSTNAME = [
    // "localhost",
    "10.3.14.121",
    "uat.hlb.com.my",
    "uat.hlisb.com.my",
    "t1uat.hongleongconnect.com.my",
    "www.hlb.com.my",
    "www.hlisb.com.my",
    "s.hongleongconnect.my",
];

export const CLIENT_SECRET = "3234";
export const PLACEHOLDER_ANSWER = "LIVE_AGENT_TEXT_PLACEHOLDER";
export const PLACEHOLDER_QUESTION = "USER_AGENT_TEXT_PLACEHOLDER";
export const FIVE_MIN = 5 * 60 * 1000;
